import React from "react";
import MaterialUISelect from "../../../common/selects/MaterialUISelect";
import {getGroupChartDataType} from "../../../../utils/chartUtils";


export default function GroupChartDataSelect({value, onSelect, statisticType, donutChart=false, width}) {
    return (
    <div >
        <MaterialUISelect dropdownData={getGroupChartDataType(statisticType).filter(item => !(donutChart && item.hideIfDonut))}
                          selectedValue={value} onSelectCallbackFunction={onSelect} styles={{paper: {maxHeight: 150}, root: {minWidth: 120, width: width}}}/>
    </div>
    );
}